import React from 'react';
import styled from 'styled-components';
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import { getColor } from 'common/constants/_colors';

const Triangle = styled.div`
  width: 0;
  height: 0;
  border: 1.4rem solid transparent;
  border-top: 0;
  border-bottom: 2.6rem solid ${getColor('chambray')};
  transform: rotate(${({ isLeft }) => (isLeft ? 270 : 90)}deg);
`;
const DashedLine = styled.div`
  border-bottom: 0.188rem dashed ${getColor('chambray')};
  width: ${({ width }) => width};
`;

const ArrowedText = ({ text, isArrowLeft, arrowLength, ...rest }) => (
  <Flex {...rest} {...(arrowLength ? { items: 'flex-start' } : {})}>
    {isArrowLeft && (
      <Flex items='center'>
        <Triangle isLeft={isArrowLeft} />
        {arrowLength && <DashedLine width={arrowLength} />}
      </Flex>
    )}
    <Text
      width='17.3rem'
      size='x-medium'
      lineHeight='2rem'
      weight={400}
      ml={isArrowLeft && '1.5rem'}
      mr={!isArrowLeft && '1.5rem'}
    >
      {text}
    </Text>
    {!isArrowLeft && (
      <Flex items='center'>
        {arrowLength && <DashedLine width={arrowLength} />}
        <Triangle isLeft={isArrowLeft} />
      </Flex>
    )}
  </Flex>
);
export default ArrowedText;
